import * as React from 'react';

import LoginEmail from './email/LoginEmail';

const Landing = () => {
    return <LoginEmail />;
};

export default Landing;
